<template>
    <v-avatar width="100%" height="100%" tile color="grey lighten-4">
        <v-img v-if="hasAvatar" :src="expert.avatar.url" :alt="`${expert.companyName} 로고`" contain />
        <v-icon v-else size="4rem">mdi-domain</v-icon>
    </v-avatar>
</template>

<script>
import { USER_TYPES } from "@/assets/data/CONSTANTS";
export default {
    props: { expert: Object },
    computed: {
        hasAvatar(){
            return !!this.expert?._avatar
        },
        isOrganization() {
            return this.expert?.type == USER_TYPES.ORGANIZATION;
        },
        isIndividual() {
            return this.expert?.type == USER_TYPES.INDIVIDUAL;
        },
        imgAlt() {
            if (this.isOrganization) return `${this.expert?.companyName} 로고`;
            if (this.isIndividual) return `${this.expert?.nickname} 사진`;
        },
    },
};
</script>

<style></style>
